module.exports = __webpack_public_path__ + "img/ymkjbanner2.64338853.png";